<div class="barcode-scanner-container">
  <div class="header">
    <button class="btn-back" (click)="goBack()">
      ← Retour
    </button>
    <h2>Scanner un code-barres</h2>
  </div>

  <app-barcode-scanner 
        [isProcessing]="isProcessing"
        (scanSuccess)="handleProductLookup($event)">
      </app-barcode-scanner>

  <div class="tips">
    <p>💡 Conseils :</p>
    <ul>
      <li>Assurez-vous d'avoir un bon éclairage</li>
      <li>Tenez le téléphone stable</li>
      <li>Placez le code-barres bien droit dans le cadre</li>
      <li>Changez de caméra si besoin</li>
    </ul>
  </div>
</div>